import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const token = useSelector((state) => state.auth.token);

  if (!token) {
    // Jeśli nie ma tokenu, przekierowujemy do logowania
    return <Navigate to="/login" />;
  }

  return children; // Jeśli jest token, renderujemy chroniony komponent
};

export default ProtectedRoute;
